import React, {useState, Fragment} from 'react';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import DatosDeEmpresa from 'components/nuevoTarifario/DatosDeEmpresa';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import {useDispatch} from 'react-redux';
import NuevaVallaFija from './NuevaVallaFija';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import { nuevoOActualizarRegistroPersonalizado, obtenerRegistrosPorURL } from 'store/actions/customAction';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';
import DetalleDeLaVallaFija from './DetalleDeLaVallaFija';

const VallasFijas = () => {
    const dispatch = useDispatch();
    const [tarifarioDeVallasFijas] = useState('tarifarioDeVallasFijas');
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
    const[cargandoSolicitud, setCargandoSolicitud] = useState(false);
    const [abrirNuevaVallaFija, setAbrirNuevoVallaFija] = useState(false);
    const [datosDeEmpresa, setDatosDeEmpresa] = useState({});
    const [recargarLaTabla, setRecargarLaTabla] = useState(false),
    [datosGeneralesDelTarifario, setDatosGeneralesDelTarifario] = useState({}),
    [abrirDetalleTarifario, setAbrirDetalleTarifario] = useState(false),
    [alertaDeConfirmacion, setAlertaDeConfirmacion] = useState(false);

    const [header] = useState([
        { title: 'Departamento', field: 'departamento.nombre'},
        { title: 'Coordenadas de ubicación', field: 'coordenadas'},
        { title: 'Acciones', field: 'accion',
        render: rowData=><div style={{minWidth: '100px'}}>
            {
                (<div>

                    <TooltipPersonalizado title="Visualizar detalle de la valla fija" handleFunction={() => mostrarDetalleDelMedio(rowData)} icon="visibility" fontSize={30} />
                    <TooltipPersonalizado title="Editar valla fija" handleFunction={() => editarVallaFija(rowData)} icon="edit" fontSize={30} />
                    <TooltipPersonalizado title="Eliminar valla fija" handleFunction={() => mostrarAlertaDeConfirmacion(rowData)} icon="delete" fontSize={30} color="red" />

                </div>)
            }
            </div>
        },
    ]);

    const mostrarAlertaDeConfirmacion = async (elemento) => {
        setDatosGeneralesDelTarifario(elemento)
        setAlertaDeConfirmacion(true)
    }

    const editarVallaFija = async (elemento) => {
        setDatosGeneralesDelTarifario(elemento)
        setAbrirNuevoVallaFija(true);
    }

    const mostrarDetalleDelMedio = async (elemento) => {
        setCargandoSolicitud(true);

        let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: tarifarioDeVallasFijas, saveInStore: false, nombreDelMetodo: "listar/registros", parametro: elemento.medioDeComunicacion?.id}));

        setCargandoSolicitud(false);

        if(respuesta?.error) return alertaPersonalizadaSwal(`${respuesta.error?.message || "No se pudo obtener la información del valla"}`);

        if(respuesta?.data?.length === 0) return alertaPersonalizadaSwal("No existen datos para mostrar");

        setDatosGeneralesDelTarifario(respuesta.data)
        setAbrirDetalleTarifario(true)
    }

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => setDatosDeRespuesta({tipoDeAlerta,mensajeDeAlerta,mostrarRespuesta,})

    const addRegister= () => {
        setDatosGeneralesDelTarifario({})
        if(!datosDeEmpresa?.ejecutivoDeMedios?.cui) return alertaPersonalizadaSwal("Debe completar los datos Contacto de medios para agregar otra valla fija", "", "warning")
        setAbrirNuevoVallaFija(true);
    }

    const datosEditados = (respuesta) => {
        alertaPersonalizadaSwal(respuesta || "Datos editados correctamente", "", "success")
        setAbrirNuevoVallaFija(false);
        setRecargarLaTabla(true)
    }

    const cerrarNuevaVallaFija= (recargar = false) => {
        setAbrirNuevoVallaFija(false)
        setRecargarLaTabla(recargar)
    };

    const cerrarDetalleDelTarifario = () => setAbrirDetalleTarifario(false)

    const accionDeAlertaDeConfirmacion = async () => {
        setAlertaDeConfirmacion(false);
        setCargandoSolicitud(true);
        changeDataResponse('error', "")

        const data = { controller: tarifarioDeVallasFijas, action: 'deshabilitar', data: {}, nombreDelMetodo: `deshabilitar/${datosGeneralesDelTarifario?.medioDeComunicacion?.id}` };
        const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(data));
        setCargandoSolicitud(false);
        if(respuesta?.error) return alertaPersonalizadaSwal(respuesta.error?.message || "", "", '');
        alertaPersonalizadaSwal(respuesta?.data || "Registro eliminado correctamente", "", 'success');
        setRecargarLaTabla(true)
    }

    const cerrarAlertaDeConfirmacion = () => setAlertaDeConfirmacion(false);

    const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>

            <DatosDeEmpresa
                header={header}
                tituloGeneral={"FORMULARIO DE REGISTRO VALLAS FIJAS"}
                icon={"vallas_fijas"}
                tituloDeTabla={"LISTADO DE VALLAS FIJAS"}
                addRegister={addRegister}
                nombreToolTip={"AGREGAR VALLA FIJA"}
                iconTabla={"vallas_fijas"}
                setDatosDeEmpresa={setDatosDeEmpresa}
                controladorTarifario={"tarifarioDeVallasFijas"}
                recargarLaTabla={recargarLaTabla}
                datosDeEmpresa={datosDeEmpresa}
                setRecargarLaTabla={setRecargarLaTabla}
                tipoMedio="vallasFijas"
            />

            {abrirNuevaVallaFija && (
                <NuevaVallaFija
                    openFullScreenDialog={abrirNuevaVallaFija}
                    handleClose={cerrarNuevaVallaFija}
                    title={"Formulario para agregar nueva valla fija"}
                    datosDeEmpresa={datosDeEmpresa}
                    datosGeneralesDelTarifario={datosGeneralesDelTarifario}
                    datosEditados={datosEditados}
                />
            )}
            {abrirDetalleTarifario && (
                <DetalleDeLaVallaFija
                    openFullScreenDialog={abrirDetalleTarifario}
                    handleClose={cerrarDetalleDelTarifario}
                    title={'Detalle del valla registrada'}
                    datosGeneralesDelTarifario={datosGeneralesDelTarifario}
                />
            )}
            {alertaDeConfirmacion && (
                <ModalDeConfirmacion
                    title={`¿Está seguro de eliminar la valla ${datosGeneralesDelTarifario?.medioDeComunicacion?.nombre || ""}?`} message={"No podrá revertir esta acción"}
                    open={alertaDeConfirmacion} closeModal={cerrarAlertaDeConfirmacion} titleButton={"Sí, estoy seguro"}
                    actionAdd={accionDeAlertaDeConfirmacion}
                />
            )}
        </Fragment>
    );
}

export default VallasFijas;